import { useState, useEffect } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import { Typography, Box, Tooltip, IconButton, InputBase } from "@mui/material";
import { DataGrid, faIR } from "@mui/x-data-grid";
import AddDirectDisccount from "./AddDirectDisccount";
import { UseDiscountManagment } from "../UseDiscountManagment";
import { useLocation } from "react-router-dom";
import { UseMyPC } from "../../../hooks/UseMyPC";
import CustomPagination from "../../../components/CustomPagination";
import ProgressCom from "../../../components/ProgressCom";
import Detail from "../../../main/detail/Detail";
import { deCapitalizeFirstLetter } from "../../../util/Utils";
import DeleteRow from "../../../components/DeleteRow";
import { rsProgress, rsActiveMenu } from "../../../RecoilStates";
import { useRecoilState } from "recoil";

export default function DirectDiscountList() {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const location = useLocation();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { getDirectDiscount, deleteDirectDiscount } = UseDiscountManagment();
  const {
    myPc,
    goToLastPage,
    goToFirstPage,
    updatePage,
    updateSort,
    setScrollTo,
    refresh,
  } = UseMyPC("discountPercent", "Desc");
  const [search, setSearch] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [searchState, setSearchState] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [productRes, setProductRes] = useState();
  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });

  function handleSearch(value) {
    setScrollTo(undefined);
    location.state = null;
    setSearch(value);
  }

  useEffect(() => {
    if (
      myPc.page === 0 ||
      (location.state && location.state && location.state.isBack)
    ) {
      return;
    }
    setProgress(true);
    getDirectDiscount(myPc, search, (products) => {
      setProductRes(products);
    });
  }, [myPc]);

  useEffect(() => {
    if (location.state && location.state) {
      location.state.isBack = false;
    }
    if (search.length > 0 && !location.state) {
      goToFirstPage();
    } else {
      refresh();
    }
  }, [search]);

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "id",
      headerAlign: "center",
    },
    {
      field: "productName",
      headerName: "نام محصول",
      width: 300,
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.productName}
          </Typography>
        );
      },
    },
    {
      field: "group",
      headerName: "گروه",
      width: 190,
      align: "left",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.group}
          </Typography>
        );
      },
    },
    {
      field: "brand",
      headerName: "برند",
      width: 150,
      align: "left",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.brand}
          </Typography>
        );
      },
    },
    {
      field: "discountPercent",
      headerName: "درصد تخفیف",
      width: 130,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.discountPercent}
          </Typography>
        );
      },
    },
    {
      field: "عملیات",
      sortable: false,
      width: 90,
      headerAlign: "center",
      align: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Tooltip title="حذف">
              <IconButton
                onClick={() => {
                  setDeleteState({
                    show: true,
                    name: cellValues.row.productName,
                    productID: cellValues.row.id,
                  });
                }}
              >
                <DeleteIcon sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
          </Box>
        );
      },
    },
    {
      field: "search",
      width: 250,
      sortable: false,
      renderHeader: (cellValues) => {
        return (
          <Box
            sx={{ border: "1px solid #d3d3d3", borderRadius: 1 }}
            width="auto"
            display="flex"
            justifyContent="flex-start"
          >
            <InputBase
              sx={{ ml: 2, flex: 1 }}
              placeholder="جستجو"
              value={searchState}
              inputProps={{ "aria-label": "search" }}
              onChange={(evt) => {
                if (evt.target.value == "") {
                  handleSearch("");
                }
                setSearchState(evt.target.value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearch(searchState);
                }
              }}
            />
          </Box>
        );
      },
    },
  ];

  return (
    <Detail
      breadChilds={{
        backButtonDef: {
          state: location.state,
          replace: true,
        },
        backURL: "/discountmanagment",
        title: "محصولات",
        childs: [
          {
            name: msActiveMenu.pageTitle,
            url: "/discountmanagment",
          },
          {
            name: "تخفیف مستقیم",
            url: "/discountmanagment/directDiscount",
          },
        ],
      }}
    >
      <Box sx={{ height: "30rem", mb: 3 }}>
        {productRes ? (
          <DataGrid
            className="ltr-grid"
            localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
            columns={columns}
            pageSize={productRes.pageCondition.pageCount}
            rows={productRes.products}
            paginationMode="server"
            page={productRes.pageCondition.page - 1}
            onPageChange={(page) => {
              updatePage(page + 1);
            }}
            rowCount={
              productRes?.pageCondition.totalItemCount
                ? productRes.pageCondition.totalItemCount
                : 1
            }
            enableRangeSelection={true}
            disableColumnMenu
            hideFooterSelectedRowCount
            components={{
              Pagination: CustomPagination,
            }}
            componentsProps={{
              pagination: {
                scrollTo: myPc.scrollTo,
                isLtr: true,
                nofab: true,
                rowCount: productRes?.pageCondition.totalItemCount
                  ? productRes.pageCondition.totalItemCount
                  : "",
              },
            }}
            initialState={{
              sorting: {
                sortModel: [
                  {
                    field: deCapitalizeFirstLetter(myPc.sortColumn),
                    sort: deCapitalizeFirstLetter(myPc.sortOrder),
                  },
                ],
              },
              pagination: {
                page: myPc.page,
              },
            }}
            onSortModelChange={(model) => {
              updateSort(
                model[0].field,
                model[0].sort == "asc" ? "asc" : "desc"
              );
            }}
            sortingOrder={["desc", "asc"]}
            sortingMode="server"
          />
        ) : (
          <ProgressCom></ProgressCom>
        )}
      </Box>
      <AddDirectDisccount
        callback={() => {
          setProgress(true);
          refresh();
        }}
      />
      <DeleteRow
        deleteState={deleteState}
        setDeleteState={setDeleteState}
        type={"محصول"}
        callback={() => {
          setProgress(true);
          let model = {
            productID: deleteState.productID,
          };
          deleteDirectDiscount(model, () => {
            refresh();
          });
        }}
      ></DeleteRow>
    </Detail>
  );
}
